module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/11d9852911e7b7661cf97a5a1b0ac8b6.png";